export default {
  name: "Starbourne Labs",
  dates: "Feb 2025 – Sep 2026",
  title: "Full-Stack Software Engineer",
  technologies:
    "Python, TypeScript, Golang, FastAPI, React, PostgreSQL, Supabase, JWT, gRPC, protobuf, LangChain, Pipecat, Elasticsearch, RabbitMQ",
  groups: [
    {
      heading: "SEC/FINRA compliance platform",
      bullets: [
        "Designed and built the underlying role-based access control (RBAC) system a financial platform relies on. Migrated 20 database tables in six weeks; shipped to prod without disrupting existing customers.",
        "Rearchitected row-level security (RLS) onto JWT claims, taking the platform’s slowest query from 30 seconds to 5 ms (6,000×).",
        "Architected the multi-tenancy model: kept RLS on a single-org expectation and passed active org via JWT, making cross-org data leakage structurally impossible rather than policy-enforced.",
        "Built a combinatorial proof that no user, whatever their role or org type, can reach a part of the app they shouldn’t, with a CI guard that fails when a new route ships untested.",
        "Built the brokerage-data integration behind the platform’s monitoring and quarterly SEC/FINRA certifications, including AES-256-GCM encryption of access tokens. Cut account-connection wait from 15 seconds, during which the product wrongly reported failure, to under 2.",
        "Built completeness guarantees into quarterly compliance attestations, closing defects that could have let a certification be signed against a partial record.",
        "Initiated and ran a SOC 2 readiness review of the platform, then shipped the fixes it surfaced.",
      ],
    },
    {
      heading: "AI-driven test-orchestration platform",
      bullets: [
        "Built the diagnostic reporting and correlation-ID logging for a concurrent Golang state-machine test engine, piping sequenced logs into Elasticsearch and turning “why did this run fail?” from days of investigation into a lookup.",
        "Hardened the engine’s concurrency: added semaphore-based limits with wait-time telemetry around the NLP and vision-model calls, and fixed a manager memory leak and a run-completion race.",
      ],
    },
    {
      heading: "Conversational AI agents",
      bullets: [
        "Built and delivered a client’s AI agent end to end and solo in five weeks, including its retrieval-augmented generation (RAG) knowledge base and operator interface. First milestone four days early.",
        "Built the real-time voice pipeline for a multi-platform AI comedian agent on Telegram and X, plus its external-context subsystem: live Perplexity search and trending-topic retrieval.",
      ],
    },
  ],
};
